import { userIsNotAuthenticatedRedir } from 'components/auth/hoc';
import { compose } from 'recompose';
import Login from './Login.styled';

const enhance = compose(userIsNotAuthenticatedRedir);

export default enhance(Login);
